export const selectOwnState = (state) => {
    return state.router
}

export const selectLocation = (state) => {
    return selectOwnState(state).location
}

export const selectLocationPath = (state) => {
    return selectLocation(state).pathname
}




// WEBPACK FOOTER //
// ./src/modules/router/selector.js